import styled from 'styled-components';

const Wrapper = styled.div`
  text-align: center;
`;

export default Wrapper;